import { createFileRoute } from '@tanstack/react-router'
import React from "react";
import LeaguesView from "../../../leagues/LeaguesView.tsx";

export const Route = createFileRoute('/_app/leagues/$league_uid')({
  component: RouteComponent,
})

function RouteComponent() {
  return <LeaguesView />
}
